import React, { useState, useEffect, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import { handleSettingsIconActiveToggle } from 'src/redux/Actions/Settings';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as ProfileIcon } from 'src/Images/icons/common/ProfileIcon.svg';
//
import { ReactComponent as EnterpriseIcon } from 'src/Images/icons/common/EnterpriseIcon.svg';
import { ReactComponent as VehicleTrackingIcon } from 'src/Images/icons/common/vehicalTrackingIcon.svg';
import { ReactComponent as SyncEventIcon } from 'src/Images/icons/common/SyncEvent.svg';
import { ReactComponent as ProductIcon } from 'src/Images/icons/common/ProductIcon.svg';
import { ReactComponent as AccountIcon } from 'src/Images/icons/common/AccountIcon.svg';
import { ReactComponent as PurchaseOrderIcon } from 'src/Images/icons/common/PurchaseOrderIcon.svg';
import { ReactComponent as StageIcon } from 'src/Images/icons/common/StageIcon.svg';
import { ReactComponent as OrganisationIcon } from 'src/Images/icons/common/OrganisationIcon.svg';
import { ReactComponent as PackTypeIcon } from 'src/Images/icons/common/PackTypeIcon.svg';
import { ReactComponent as QualityIcon } from 'src/Images/icons/common/Quality.svg';
import { ReactComponent as DimensionIcon } from 'src/Images/icons/common/Dimension.svg';
import { ReactComponent as QualityCheck } from 'src/Images/icons/common/QualityCheck.svg';
import getColorCode from 'src/utils/GetThemeColor';
import 'src/style/settings.css';
import { useMediaQuery } from '@mui/material';
import usePageTitle from 'src/utils/SetPageTitle';
import { useNavigate, useLocation } from 'react-router-dom';
import Breadcrumb from 'src/components/Breadcrumb';
import { useSetBreadcrumbData } from 'src/utils/SetBreadcrumbData';

export default function Settings() {
  usePageTitle('Cloud Vehicle Tracking • Settings');
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:767px)');
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const [selectedItem, setSelectedItem] = useState(1);
  const sectionRefs = useRef({});
  const isSuperAdmin = authReducer.superAdmin;
  const { normalUser } = authReducer;

  const sidebarItems = [
    {
      id: 1,
      label: 'Profile',
      icon: ProfileIcon,
      description: 'Personalize your account and manage preferences.',
      visibleToSuperAdminOnly: false,
      visibleToNormalUser: true,
    },
    {
      id: 2,
      label: 'Enterprise',
      icon: EnterpriseIcon,
      description: 'Advanced tools and controls for large teams.',
      visibleToSuperAdminOnly: false,
      visibleToNormalUser: true,
    },
    {
      id: 3,
      label: 'Vehicle Tracking',
      icon: VehicleTrackingIcon,
      description: 'Track vehicles in real time.',
      visibleToSuperAdminOnly: false,
      visibleToNormalUser: false,
    },
    {
      id: 4,
      label: 'Sync Event',
      icon: SyncEventIcon,
      description: 'Keep data accurate and consistent in real time.',
      visibleToSuperAdminOnly: true,
      visibleToNormalUser: false,
    },
    {
      id: 5,
      label: 'Quality',
      icon: QualityIcon,
      description:
        'Define dimensions and checks to maintain quality standards.',
      visibleToSuperAdminOnly: false,
      visibleToNormalUser: true,
    },
  ];

  const rightSections = [
    {
      id: 1,
      label: 'Profile',
      visibleToSuperAdminOnly: false,
      visibleToNormalUser: true,
      items: [
        {
          id: 1,
          icon: ProfileIcon,
          title: 'General',
          description:
            'Update your basic profile information, contact details, and overall preferences.',
          path: '/general',
          visibleToSuperAdminOnly: false,
          visibleToNormalUser: true,
        },
      ],
    },
    {
      id: 2,
      label: 'Enterprise',
      visibleToSuperAdminOnly: false,
      visibleToNormalUser: true,
      items: [
        {
          id: 1,
          icon: ProductIcon,
          title: 'Product',
          description: 'Organize and control product-related data and details.',
          path: '/products',
          visibleToSuperAdminOnly: false,
          visibleToNormalUser: false,
        },
        {
          id: 2,
          icon: ProfileIcon,
          title: 'Users',
          description:
            'Define roles, permissions, and access levels for teams.',
          path: '/users',
          visibleToSuperAdminOnly: false,
          visibleToNormalUser: false,
        },
        {
          id: 3,
          icon: OrganisationIcon,
          title: 'Organisation',
          description: 'View and manage the organisation.',
          path: '/organisation',
          visibleToSuperAdminOnly: false,
          visibleToNormalUser: true,
        },
      ],
    },
    {
      id: 3,
      label: 'Vehicle Tracking',
      visibleToSuperAdminOnly: false,
      visibleToNormalUser: false,
      items: [
        {
          id: 1,
          icon: StageIcon,
          title: 'Stages',
          description:
            'Check the stages a vehicle passes through on its route.',
          path: '/stages',
          visibleToSuperAdminOnly: false,
          visibleToNormalUser: false,
        },
        {
          id: 2,
          icon: PackTypeIcon,
          title: 'Pack Type',
          description: 'Type and specifications of the packaging used.',
          path: '/pack-type-assignment',
          visibleToSuperAdminOnly: false,
          visibleToNormalUser: false,
        },
      ],
    },
    {
      id: 4,
      label: 'Sync Event',
      visibleToSuperAdminOnly: true,
      visibleToNormalUser: false,
      items: [
        {
          id: 1,
          icon: AccountIcon,
          title: 'Account',
          description: 'View and manage account sync events.',
          path: '/account',
          visibleToSuperAdminOnly: true,
          visibleToNormalUser: false,
        },
        {
          id: 2,
          icon: ProductIcon,
          title: 'Product',
          description: 'View and manage product sync events.',
          path: '/product',
          visibleToSuperAdminOnly: true,
          visibleToNormalUser: false,
        },
        {
          id: 3,
          icon: PurchaseOrderIcon,
          title: 'Purchase Order',
          description: 'View andc manage purchase order events.',
          path: '/purchase-order',
          visibleToSuperAdminOnly: true,
          visibleToNormalUser: false,
        },
        {
          id: 4,
          icon: PurchaseOrderIcon,
          title: 'Sales Order',
          description: 'View and manage Sales Order.',
          path: '/sales-order',
          visibleToSuperAdminOnly: true,
          visibleToNormalUser: false,
        },
        {
          id: 5,
          icon: PurchaseOrderIcon,
          title: 'Goods Received Note',
          description: 'View and manage Goods Received Note.',
          path: '/goods-received-note',
          visibleToSuperAdminOnly: true,
          visibleToNormalUser: false,
        },
      ],
    },
    {
      id: 5,
      label: 'Quality',
      visibleToSuperAdminOnly: false,
      visibleToNormalUser: true,
      items: [
        {
          id: 1,
          icon: DimensionIcon,
          title: 'Dimensions',
          description: 'Add and manage custom dimensions.',
          path: '/dimensions',
          visibleToSuperAdminOnly: false,
          visibleToNormalUser: true,
        },
        {
          id: 2,
          icon: QualityCheck,
          title: 'Quality check',
          description: 'Add and manage custom dimensions.',
          path: '/quality-check-list/',
          visibleToSuperAdminOnly: false,
          visibleToNormalUser: true,
        },
      ],
    },
  ];

  useEffect(() => {
    dispatch(handleSettingsIconActiveToggle(true));
    return () => {
      dispatch(handleSettingsIconActiveToggle(false));
    };
  }, [dispatch]);

  const handleSidebarClick = (id) => {
    setSelectedItem(id);
    if (sectionRefs.current[id]) {
      sectionRefs.current[id].scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const filteredSidebarItems = sidebarItems.filter((section) =>
    isSuperAdmin
      ? true
      : !section.visibleToSuperAdminOnly &&
        (!normalUser || section.visibleToNormalUser),
  );

  const filteredRightSections = rightSections
    .map((section) => ({
      ...section,
      items: section.items.filter((item) =>
        isSuperAdmin
          ? true
          : !item.visibleToSuperAdminOnly &&
            (!normalUser || item.visibleToNormalUser),
      ),
    }))
    .filter((section) =>
      isSuperAdmin
        ? true
        : !section.visibleToSuperAdminOnly &&
          (!normalUser || section.visibleToNormalUser),
    );

  useSetBreadcrumbData(location.pathname, 'Settings');

  return (
    <div className="page-layout">
      <Row className="g-0">
        <Col xxl={12} xl={12} lg={12} md={12}>
          <div className="div-space-between left-padding padding-bottom-8 border-bottom">
            <div className="div-flex-row cg-5">
              <Breadcrumb />
            </div>
          </div>
        </Col>
      </Row>

      <Row className="m-0">
        {!isMobile && (
          <Col xxl={3} xl={3} lg={3} md={3} className="p-0">
            <div className="setting-sidebar-container">
              <div className="text-lg text-semi-bold border-bottom body-container-padding">
                Settings
              </div>
              <div
                className={`theme-scrollable-container-${themeColor} sidebar-container-padding setting-left-container`}
              >
                {filteredSidebarItems.map(
                  ({ id, label, icon: Icon, description }) => (
                    <div
                      key={id}
                      role="button"
                      tabIndex={0}
                      className={`setting-pill-container ${
                        selectedItem === id
                          ? `theme-settingV2-overlay-${themeColor}`
                          : ''
                      }`}
                      onClick={() => handleSidebarClick(id)}
                    >
                      <div className="div-flex-row cg-20">
                        <span>
                          <Icon
                            className="icon-size-xxl"
                            color={getColorCode(themeColor)}
                          />
                        </span>
                        <div>
                          <div className="text-md text-semi-bold">{label}</div>
                          <div className="text-sm text-grey">{description}</div>
                        </div>
                      </div>
                    </div>
                  ),
                )}
              </div>
            </div>
          </Col>
        )}

        <Col
          xxl={9}
          xl={9}
          lg={9}
          md={9}
          className={`theme-scrollable-container-${themeColor} border-bottom border-left p-0 setting-right-container`}
        >
          {filteredRightSections.map(({ id, label, items }) => (
            <div
              key={id}
              ref={(el) => {
                sectionRefs.current[id] = el;
              }}
              className="div-flex-column rg-10 setting-right-side-container"
            >
              <div className="text-lg text-semi-bold left-padding">{label}</div>
              <Row className="m-0">
                {items.map(
                  ({ id: itemId, icon: Icon, title, description, path }) => (
                    <Col
                      key={itemId}
                      xxl={4}
                      xl={4}
                      lg={4}
                      md={4}
                      className="p-0"
                    >
                      <div
                        role="button"
                        tabIndex={0}
                        className={`div-flex-row cg-10 setting-right-item-container cursor-pointer theme-setting-overlay-hover-${themeColor}`}
                        onClick={() => navigate(path)}
                      >
                        <span>
                          <Icon
                            className="icon-size-xxl"
                            color={getColorCode(themeColor)}
                          />
                        </span>
                        <div>
                          <div className="text-md text-semi-bold">{title}</div>
                          <div className="text-sm text-grey">{description}</div>
                        </div>
                      </div>
                    </Col>
                  ),
                )}
              </Row>
            </div>
          ))}
        </Col>
      </Row>
    </div>
  );
}
